/**
 * dvh 单位兜底工具。
 *
 * 背景:旧浏览器 / 旧 WebView(Chrome < 108、Safari < 15.4 等)不支持 dvh 单位,
 * 声明会被整条丢弃,只能落到 100vh —— 而 iOS/安卓上 100vh 往往包含地址栏(搜索栏)高度,
 * 导致内容被地址栏遮挡。
 *
 * 方案:用 JS 读取「当前真实可视高度」(visualViewport.height,已排除地址栏/键盘占用),
 * 把它的 1% 写入根节点 CSS 变量 --app-dvh。
 * CSS 侧配合 @supports not (height: 100dvh) 使用:
 *   height: calc(var(--app-dvh, 1vh) * 100);
 * 其中 1vh 是 JS 未执行时的最终兜底。
 */
export function installDvhFallback(): void {
  // 步骤1:浏览器原生支持 dvh 时无需兜底,直接返回,不挂任何监听
  if (typeof CSS !== 'undefined' && CSS.supports?.('height', '100dvh')) return;

  // 步骤2:计算真实可视高度并写入 CSS 变量(优先 visualViewport,能感知地址栏收起/展开)
  const update = (): void => {
    const height = window.visualViewport?.height ?? window.innerHeight;
    document.documentElement.style.setProperty('--app-dvh', `${height * 0.01}px`);
  };

  // 步骤3:立即执行一次,并在视口变化(地址栏显隐、旋转屏幕、窗口缩放)时持续更新
  update();
  window.visualViewport?.addEventListener('resize', update);
  window.addEventListener('resize', update);
  window.addEventListener('orientationchange', update);
}
